<template>
  <div class="wrap">
    <img class="herderImg" src="/images/pullNew/sendFeedback_header.png" alt="">
    <div class="questionBox">
      <div v-for="(item,index) of detail.questions" :key="index" class="questionItem">
        <div class="questionName" v-if="item.questionType=='single_choice'">{{item.question}}</div>
        <div class="numBox" v-if="item.questionType=='single_choice'">
          <div v-for="(num,numIndex) of 10" :key="numIndex" :class="item.chooseNum&&item.chooseNum>=num?'chooseNum num':'num'" @click="numClick(index,num)">{{ num }}</div>
        </div>

        <div class="questionName2" v-if="item.questionType=='text'">{{item.question}}</div>
        <div class="textBox" v-if="item.questionType=='text'">
          <textarea v-model="item.textContent" class="textBorder" placeholder="请填写意见，如有不满意的地方详细描述，我们一定会给您满意答复"></textarea>
        </div>
      </div>
    </div>
    <div class="btnBox">
      <div class="btn" @click="submitFn">提交问卷激活质保卡</div>
    </div>

    <van-popup v-model="successPopup">
      <div class="myPopup" @click="clickPopup">
        <img class="myPopupImg" src="/images/pullNew/sendFeedback_success.png" alt="">
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from 'vant';
import pullnewApi from '@/axios/pullnew'
import zhugeObj from '@/assets/js/track';
import wxShare from "@/assets/js/wx.share"
export default {
  name: 'sendFeedback',
  data() {
    return {
      successPopup: false,
      detail: {
        questions: []
      },
      orderId: this.$route.query.orderId,
      customerName: this.$route.query.customerName,
      shopImg: this.$route.query.shopImg?JSON.parse(this.$route.query.shopImg):''
    }
  },
  created() {
    this.getDetail()
    zhugeObj.track({
      title: '新评价页面-曝光',
    })
  },

  mounted(){
    setTimeout(()=>{
          let shareBody = {
            title : `${this.customerName}快来领取你的宝贝质保卡，工艺问题免费返工`,
            desc : '为本次服务打分可激活质保卡',
            link : `https://mi.baozheng.cc/sendFeedback?orderId=${this.orderId}`,
            imgUrl: this.shopImg
          }; 
          wxShare(shareBody);
      },1000)
      if(this.customerName) {
        // 客服扫码进来 调取已推送接口
        pullnewApi.scanPush({orderId:this.orderId}).then((res) => {})
      }
  },

  methods:{
    clickPopup() {
      this.$router.push({ name: "orderList", params: { type: 5 } });
    },

    submitFn() {
      let oldDetail = JSON.parse(JSON.stringify(this.detail)),questions = []
      for(let index in oldDetail.questions) {
        if(oldDetail.questions[index].questionType == 'single_choice'&&!oldDetail.questions[index].chooseNum) {
          Toast(`请选择第${Number(index)+1}项的评分`)
          return
        }
        let qObj = null
        if(oldDetail.questions[index].questionType == 'single_choice') {
          qObj = {
            questionId: oldDetail.questions[index].id,
            question: oldDetail.questions[index].question,
            score: Number(oldDetail.questions[index].chooseNum)
          }
        } else if(oldDetail.questions[index].questionType == 'text') {
          qObj = {
            questionId: oldDetail.questions[index].id,
            question: oldDetail.questions[index].question,
            answerText: oldDetail.questions[index].textContent?oldDetail.questions[index].textContent:''
          }
        }
        questions.push(qObj)
      }

      let params = {
        surveyId: oldDetail.id,
        orderId: this.orderId,
        questions
      }
      pullnewApi.submitSurvey(params).then((res) => {
        this.successPopup = true
      })
      zhugeObj.track({
        title: '新评价页面-点击提交',
      })

    },

    getDetail() {
      pullnewApi.getSurvey({id:1}).then((res) => {
        this.detail = res
      })
    },

    numClick(index,num) {
      this.$set(this.detail.questions[index],'chooseNum',num)
    }
  }
}
</script>

<style scoped lang="scss">
*{
  margin: 0;
  padding: 0;
}
.wrap{
  height: 100vh;
    background-color: rgb(184, 211, 212);
  .herderImg{
    width: 100%;
    display: block;
  }
  .questionBox{
    width: 100%;
    .questionItem{
      width: 100%;
      .questionName{
        width: 100%;
        height: 80px;
        font-size: 34px;
        line-height: 80px;
        box-sizing: border-box;
        padding-left: 20px;
        font-weight: bold;
        // color: white;
        background-color: white;
      }
      .questionName2{
        width: 100%;
        font-size: 38px;
        line-height: 80px;
        box-sizing: border-box;
        padding-left: 20px;
        // font-style: italic;
        font-weight: bold;
        background-color: rgb(184, 211, 212);
        padding-top: 0.5rem;
      }
      .numBox{
        width: 100%;
        height: 80px;
        font-size: 34px;
        line-height: 80px;
        box-sizing: border-box;
        font-weight: bold;
        color: white;
        background: linear-gradient(to right, rgb(73,176,212), rgb(243,216,100));
        display: flex;
        .num{
          width: 10%;
          text-align: center;
        }
        .chooseNum{
          color: black;
        }
      }
      .textBox{
        width: 100%;
        height: 3.2rem;
        box-sizing: border-box;
        background-color: rgb(184, 211, 212);
        padding: 0.1rem 0.4rem 0.4rem;
        .textBorder{
          border: none;
          padding: 0.2rem;
          box-sizing: border-box;
          line-height: 0.6rem;
          font-size: 0.4rem;
          width: 100%;
          height: 2.4rem;
          background-color: white;
          margin: 0 auto;
          border-radius: 0.2rem;
        }
      }
    }
  }

  .btnBox{
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: rgb(184, 211, 212);
    .btn{
        width: 50%;
        height: 90px;
        font-size: 0.4rem;
        line-height: 90px;
        box-sizing: border-box;
        margin: 0 auto;
        font-weight: bold;
        background-color: white;
        border: 2px solid black;
        border-radius: 20px;
        text-align: center;
    }
  }
}
.myPopup{
  width: 100vw;
  height: 100%;
  box-sizing: border-box;
  .myPopupImg{
    width: 100vw;
    display: block;
    margin: 30vh auto;
  }
}
.van-popup{
  background: transparent !important;
}
</style>